import React, { Component } from 'react'
import { History, Save } from '@mui/icons-material';
import { TextField } from '@mui/material';
import { ALERT_SEVERITY } from '../../components/AlertDisplay2';
import { APIData } from '../../constants/APIAdresses';
import { MUI_BTN_VARIANTS } from '../../constants/MUIConstants';
import CollapsibleTile from '../../components/CollapsibleTile';

export class CommissionConfigTile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commissionsLoading: false,
            loadReachedEnd: false,
            data: {
                defaultCommission: 0,
                monthLimit: 0,
                onlinePaymentCommission: 0,
                onlinePaymentFixedSum: 0,
                extDeliveryCommission: 0
            },
            hasOwnConfig: false,
            actions: []
        }

    }
    onSave() {
        // console.log("STATEDATA: ",JSON.stringify(this.state.data));
        if (this.state.data.update != null) {

            let myBodyData = { ...this.state.data };
            let updatePart = { ...myBodyData.update };
            delete myBodyData.update;
            delete myBodyData.shopId;
            myBodyData = { ...myBodyData, ...updatePart };
            fetch(APIData.USER + `/shop/${this.props.shopId}/commissionConfig`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(myBodyData)
            }).then(response => {
                if (response.ok) {
                    this.props.showAlertDisplay("Provisionseinstellungen gespeichert", ALERT_SEVERITY.SUCCESS);
                    this.loadCommissionData();
                } else {
                    throw new Error("Fehler beim Speichern der Provisionseinstellungen")
                }
            }).catch(error => {
                this.props.showAlertDisplay("Fehler beim Speichern der Provisionseinstellungen", ALERT_SEVERITY.ERROR);
                console.error(error);
            })
        } else {
            this.props.showAlertDisplay("Keine Änderungen zum Speichern", ALERT_SEVERITY.INFO);
        }
    }
    loadCommissionData() {
        this.setState({ commissionsLoading: true });
        fetch(APIData.USER + `/shop/0/commissionConfig`, { credentials: 'include', headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error("Fehler beim Laden der Provisionseinstellungen")
                }
            }).then(data => {
                console.log("COMMISSIONDATA: ", data);
                // let tileActions = [...this.state.actions];
                // this means the shop has a configuration otherwise if the length is 1 it means the shop has no configuration and the default values are used
                this.setState({ data: data[0], commissionsLoading: false, hasOwnConfig: data.length > 1, });
            }).catch(error => {
                this.props.showAlertDisplay("Fehler beim Laden von Provisionseinstellungen", ALERT_SEVERITY.ERROR);
                console.error(error);
                this.setState({ commissionsLoading: false });
            })
        // API CALL
    }
    updateField(field, value) {
        console.log("FIELD: ", field, " VALUE: ", value);
        this.setState(prevState => {
            const newData = { ...prevState.data };
            if (newData[field] != value) {
                if (!newData.update) {
                    newData.update = {};
                }
                newData.update[field] = value;
            } else if (newData.update && newData.update[field] != null) {
                delete newData.update[field];
                if (Object.keys(newData.update).length === 0) {
                    delete newData.update;
                }
            }
            return { data: newData };
        });
    }
    render() {
        return (
            <CollapsibleTile onCollapseChange={(isExpanded, firstExpand) => {
                console.log("ONCOLLAPSE???")
                if (isExpanded && firstExpand) {
                    // this.loadRules();
                    this.loadCommissionData();
                }
            }}
                title="Provisionseinstellungen"
                icon={<img src={require('../../assets/icons/commission.png')} width={20} height={20} />}
                isLoading={this.state.commissionsLoading}
                actions={
                    [{
                        label: "Speichern",
                        icon: <Save />,
                        variant: MUI_BTN_VARIANTS.CONTAINED,
                        disabled: this.state.commissionsLoading,
                        onClick: () => { this.onSave() }
                    }]
                }
            >
                <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", width: "100%" }}>
                    <TextField type='number' onChange={(evt) => { this.updateField("defaultCommission", evt.target.value) }} value={this.state.data.update?.defaultCommission != null ? this.state.data.update.defaultCommission : this.state.data.defaultCommission} label="Standardprovision %" />
                    <TextField type='number' onChange={(evt) => { this.updateField("monthLimit", evt.target.value) }} value={this.state.data.update?.monthLimit != null ? this.state.data.update.monthLimit : this.state.data.monthLimit} label="Monatlicher Limit €" />
                    <TextField type='number' onChange={(evt) => { this.updateField("onlinePaymentCommission", evt.target.value) }} value={this.state.data.update?.onlinePaymentCommission != null ? this.state.data.update.onlinePaymentCommission : this.state.data.onlinePaymentCommission} label="Online-Provision %" />
                    <TextField type='number' onChange={(evt) => { this.updateField("onlinePaymentFixedSum", evt.target.value) }} value={this.state.data.update?.onlinePaymentFixedSum != null ? this.state.data.update.onlinePaymentFixedSum : this.state.data.onlinePaymentFixedSum} label="Online Transaktionsgebühr (Fix) €" />
                    <TextField type='number' onChange={(evt) => { this.updateField("extDeliveryCommission", evt.target.value) }} value={this.state.data.update?.extDeliveryCommission != null ? this.state.data.update.extDeliveryCommission : this.state.data.extDeliveryCommission} label="Externe Liefergebühr %" />
                </div>
            </CollapsibleTile>
        )
    }
}

export default CommissionConfigTile